<template>
  <b-form-group
    label="Yeni Sözleşme Başlangıç Tarihi"
    label-for="sdate"
  >
    <b-form-datepicker
      id="renewal_sdate"
      v-model="dataItem.tenants.renewal_sdate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'TenantRenewalStart',
  components: {
    BFormDatepicker,
    BFormGroup,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
  },
}
</script>
